import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  dialog: {
    fontFamily: '"LLCircularWeb", "Helvetica Neue", Helvetica, Arial, sans-serif;',
  },
  dialogTitle: {
    fontFamily: '"LLCircularWeb", "Helvetica Neue", Helvetica, Arial, sans-serif;',
    fontSize: '20px',
    padding: '16px 24px',
    // @ts-expect-error - this is a valid font weight
    fontWeight: '600',
  },
  dialogContent: {
    paddingTop: '0px',
  },
  list: {
    listStyleType: 'disc',
    lineHeight: '1.4',
    marginLeft: '25px',
    marginBottom: '20px',
  },
  listItem: {
    margin: '4px 0',
  },
  alert: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-start',
    marginTop: '24px',
  },
  alertIcon: {
    width: '20px',
    color: '#00000099',
  },
  alertText: {
    fontSize: '0.8rem',
    color: '#00000099',
  },
  dialogActions: {
    paddingTop: '0px',
  },
  dialogActionButton: {
    color: '#0A5AC2',
    textTransform: 'none',
    // @ts-expect-error - this is a valid font weight
    fontWeight: '600',
    fontFamily: 'LLCircularWeb',
    fontSize: '1rem',
  },
});
